export var getErrorInfo = function (error) {
    var debugInfo;
    var message;
    if (error instanceof Error) {
        debugInfo = error.stack;
        message = error.message;
    }
    else if (typeof error === 'string') {
        message = error;
    }
    else if (typeof error === 'object') {
        message = error === null || error === void 0 ? void 0 : error.toString();
    }
    return {
        debugInfo: debugInfo !== null && debugInfo !== void 0 ? debugInfo : '',
        message: message !== null && message !== void 0 ? message : '',
    };
};
//# sourceMappingURL=getErrorInfo.js.map